module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-einvoice-status"
  }, [_c('ModalReveal', {
    on: {
      "input": _vm.closeSdiStatus
    },
    model: {
      value: (_vm.openSdiStatus),
      callback: function($$v) {
        _vm.openSdiStatus = $$v
      },
      expression: "openSdiStatus"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    on: {
      "click": _vm.open
    },
    slot: "trigger"
  }, [_vm._v("Aggiorna filename")]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Filename"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filename),
      expression: "filename"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filename = $event.target.value
      }
    }
  })])])])]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.getStatus
    },
    slot: "footer"
  }, [_vm._v("Update")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13a48cb0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/modules/einvoice/UpdateEinvoiceFileName.vue
// module id = 2227
// module chunks = 1